import { useState } from 'react';
import { Provider } from 'react-redux';
import { Route, Router, Switch } from 'react-router-dom';
import { YMInitializer } from 'react-yandex-metrika';
import { ru } from 'date-fns/locale';
import { applyMiddleware, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createTheme, CssBaseline, ThemeProvider } from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns';
import { AppGate, history } from '@features/common';
import { ErrorBoundary } from '@features/error';
import { NewsFeed } from '@pages/news-feed';
import { theme } from '../configs/theme';
import { enviroment } from '../consts/common';
import { AuthorizationPage } from '../features/authorization';
import { DashboardFullscreenPage } from '../features/dashboard-fullscreen';
import rootReducer from '../redux/reducers/_root';
import { TechnicalWork, resolveDatesForTechnicalWork } from './technical-work';
import PageLayout from './templates/PageTemplate';

const middlewares = applyMiddleware(thunkMiddleware);

const store = createStore(rootReducer, middlewares);

const cssVariablesTheme = createTheme({
  cssVariables: { colorSchemeSelector: 'data' },
  defaultColorScheme: 'light',
});

export default function App() {
  useState(() => {
    const lang = localStorage.getItem('lang');

    if (!lang) {
      const defaultLang = process.env.LANG;

      localStorage.setItem('lang', defaultLang);
      window.location.reload();
    }
  }, []);

  const technicalWorkDatesString = process.env.TECHNICAL_WORK;
  const isTechnicalWork = resolveDatesForTechnicalWork(technicalWorkDatesString);
  if (isTechnicalWork) return <TechnicalWork datesString={technicalWorkDatesString} />;

  return (
    <>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <ThemeProvider theme={cssVariablesTheme}>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ru}>
              <CssBaseline />
              {enviroment !== 'development' && (
                <YMInitializer
                  accounts={[57345664]}
                  options={{ webvisor: true, clickmap: true, trackLinks: true }}
                  version="2"
                />
              )}
              <ErrorBoundary>
                <AppGate />
                <NewsFeed />
                <Provider store={store}>
                  <Router history={history}>
                    <Switch>
                      <Route exact path="/auth" component={AuthorizationPage} />
                      <Route
                        exact
                        path="/dashboard-fullscreen"
                        component={DashboardFullscreenPage}
                      />
                      <Route path="/" component={PageLayout} />
                    </Switch>
                  </Router>
                </Provider>
              </ErrorBoundary>
            </LocalizationProvider>
          </ThemeProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </>
  );
}
